<template>
  <div class="cart_title">
    <van-nav-bar :title="'桌台号：' + UserInfo.Name" />
  </div>
  <div class="cart_content" v-if="Carts.Items.length > 0">
    <div class="cart_items">
      <div v-for="(item, index) in Carts.Items" :key="index">
        <div class="cart_item">
          <div class="item_opt">
            <van-button
              icon="minus"
              type="primary"
              size="mini"
              @click="MinusCartItem(item)"
            />
          </div>
          <div class="item_detail">
            {{ item.Count }} ✖ {{ item.ProductItem.Name }}
          </div>
          <div class="item_detail_btn">
            <van-icon name="label-o" @click="DetailOrder(item)" />
          </div>
          <div class="item_amount">
            {{ item.SubtotalFormat }}
            <van-icon
              name="label-o"
              v-if="item.ProductType == 200"
              @click="EditCollection(item)"
            />
          </div>
        </div>
        <div
          class="cart_collectionItem"
          v-for="collectionItem in item.CollectionItems"
          :key="collectionItem.Id"
        >
        <div> </div>
        
        <div>

        </div>
         <p>  {{ collectionItem.ProductItem.Name  }} {{ collectionItem.ProductItem.PriceFormat  }}  * {{ collectionItem.Count  }} =  {{ collectionItem.SubtotalFormat  }}  </p>
        </div>
      </div>
    </div>

    <!-- 详细信息 -->
    <div class="cart_total_content" v-if="Carts.Items.length > 0">
      <div class="cart_total_title" v-if="UserInfo.AccountType == 100">
        <div>桌台</div>
        <div>{{ UserInfo.Name }}</div>
      </div>

      <div class="cart_total_title">
        <div>合计</div>
        <div>{{ Carts.TotalFormat }}</div>
      </div>
      <div class="cart_total_tax">
        <div>税额</div>
        <div>{{ Carts.TaxAmountFormat }}</div>
      </div>
      <div class="cart_total_amount">
        <div>金额</div>
        <div>{{ Carts.AmountFormat }}</div>
      </div>
      <div class="cart_plan_order">
        <van-button round type="primary" block @click="PlaceAnOrder()"
          >下单</van-button
        >
      </div>
    </div>
  </div>

  <!-- 支付页面 -->
  <van-action-sheet v-model:show="PlaceOrder" title="支付">
    <div class="content">
   
      <div>
        <van-divider content-position="left" dashed>备注</van-divider>
        <van-cell-group inset>
          <van-field
            v-model="Remarks"
            rows="1"
            autosize
            label="留备注言"
            type="textarea"
            placeholder="请输入备注"
          />
        </van-cell-group>
      </div>

      <br />
      <br />
      <br />
      <van-button round type="primary" block @click="PayOrder()"
        >下单</van-button
      >
    </div>
  </van-action-sheet>

  <!-- 详细信息 -->
  <van-action-sheet v-model:show="DetailOrderWindow" title="详细信息">
    <div class="content">
      {{ CartItemOpt.Count }} ✖ {{ CartItemOpt.ProductItem.Name }}
      <p v-for="item in CartItemOpt.OptProductRemarkItems" :key="item.Id">
        {{ item.Name }} ✖ {{ item.Price }}
      </p>
      属性
      <p v-for="item in CartItemOpt.AttributesOpt" :key="item.Id">
        {{ item.Name }} ✖ {{ item.Price }}
      </p>
    </div>
  </van-action-sheet>

  <div class="cart_tips" v-if="Carts.Items.length == 0">
    <p>
      <van-icon class="cart_tips_icon" name="cart-o" />
    </p>
    <p>您的购物车是空的</p>
  </div>

  <br />
  <br />
  <br />
  <br />

  <tabbar :active="2" />
</template> 
<script >
import tabbar from "../../components/tabbars/tabbar.vue";
import addressfield from "../../components/addressfield.vue";
import paymethods from "../../components/pay-methods.vue";
import freightTransport from "../../components/freightTransport.vue";

import axios from "../../commons/AxiosMethod.js";
import commons from "../../commons/commons.js";
import { Toast } from "vant";

export default {
  data() {
    return {
      index: 0,
      clientWidth: document.body.clientWidth,
      clientHeight: document.documentElement.clientHeight,
      Carts: {
        Items: [],
      }, //购物车项目
      PlaceOrder: false,
      PaymenthodId: "", //选中支付方式
      AddressId: "", //选中支付地址
      FreightTransportId: "", //货运地址
      Remarks: "",

      DetailOrderWindow: false, //详细信息页面
      CartItemOpt: {}, //选中购物车项目

      UserInfo: {}, //用户信息
    };
  },
  name: "App",
  mounted() {
    this.GetShoppingCartComplete();
    this.GetUserInfo();
  },
  components: {
    tabbar,
    addressfield,
    paymethods,
    freightTransport,
  },
  methods: {
    EditCollection(item) {
 
      this.$router.push({
        path: "CollectionItems",
        query: { 
          collectionId: item.ProductId,
          orderId: item.OrderItemId,
          cartId:item.Id
        },
      });
    },
    //详细信息
    DetailOrder(item) {
      this.CartItemOpt = item;
      this.DetailOrderWindow = true;
    },
    //减少商品
    MinusCartItem(item) {
      axios.apiMethod(
        "/Shopping/ShoppingTrolley/MinusCartItem",
        "get",
        { Id: item.Id },
        (result) => {
          if (result.Code == 200) {
            if (result.Data) {
              this.GetShoppingCartComplete();
            }
          }
          Toast(result.Msg);
        },
        (e) => {}
      );
    },
    //下单
    PayOrder() {
      axios.apiMethod(
        "/Orders/Order/TablePlaceOrder",
        "get",
        {},
        (result) => {
          if (result.Code == 200) {
            Toast("下单成功");
            this.PlaceOrder = false;
            this.GetShoppingCartComplete();
          } else {
            Toast(result.Msg);
          }
        },
        (e) => {}
      );
    },
    PlaceAnOrder() {
      this.PlaceOrder = true;
    },
    // 获取购物车
    GetShoppingCartComplete() {
      axios.apiMethod(
        "/Shopping/ShoppingTrolley/GetTableShoppingCartComplete",
        "get",
        {},
        (result) => {
          if (result.Code == 200) {
            console.log(JSON.stringify(result.Data));
            this.Carts = result.Data;
          } else {
            Toast(result.Msg);
          }
        },
        (e) => {}
      );
    },

    //获取用户信息
    GetUserInfo() {
      var param = {};
      axios.apiMethod("/api/User/GetUserInfo", "get", param, (result) => {
        if (result.Code == 200) {
          this.UserInfo = result.Data;
        }
      });
    },
  },
};
</script>
 
 
<style lang="scss" scoped>
.cart_title {
  position: fixed;
  width: 100%;
  height: 40px;
  z-index: 50000000;
}
.cart_content {
  padding: 10px;

  .cart_items {
    background-color: #fff;
    margin: 0 auto;
    margin-top: 40px;
    overflow: auto;
    .cart_item {
      height: 50px;
      line-height: 50px;
      width: calc(100% - 30px);
      margin: 0 auto;
      display: flex;
      justify-content: space-between;

      .item_opt {
        width: 40px;
        height: 40px;
        line-height: 40px;
      }

      .item_detail {
        width: calc(100% - 140px);
        font-size: 9pt;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
        text-align: left;
        font-family: Avenir, Helvetica, Arial, sans-serif;
      }
      .item_amount {
        width: 100px;
        text-align: right;
        font-size: 11pt;
      }
    }
    .cart_collectionItem {
      width: calc(100% - 30px);
      margin:  0 auto;
      font-size: 8pt;

    }
  }

  .cart_total_content {
    max-width: 100%;
    background-color: #fff;
    margin-top: 15px;
    padding: 15px;
    .cart_total_title,
    .cart_total_tax,
    .cart_total_amount {
      border-bottom: 1px solid #eee;
      padding: 8px 20px;
      display: flex;
      justify-content: space-between;
    }
    .cart_plan_order {
      margin-top: 30px;
    }
  }
}

.content {
  .content_item {
    .content_item_title {
      width: calc(100% - 100px);
      margin-left: 20px;
      font-size: 15pt;
    }
  }
}

.cart_tips {
  position: fixed;
  top: 200px;
  width: 100%;
  text-align: center;
  .cart_tips_icon {
    font-size: 17pt;
  }
}
</style>
